import React, { Component } from "react";
import axios from "axios";
import config from "../config.js";
import validator from "email-validator";

class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      firstName: "",
      lastName: "",
      message: "",
    };
  }

  handleChange = (event) => {
    const newState = Object.assign({}, this.state, {
      [event.target.name]: event.target.value,
    });
    this.setState(newState);
  };

  handleSubmit = () => {
    if (this.state.email && this.state.firstName && this.state.lastName) {
      if (!validator.validate(this.state.email)) {
        this.setState({ message: "Please enter a valid email." });
      } else {
        let url;
        if (process.env.REACT_APP_ENV) {
          url = config.api[process.env.REACT_APP_ENV];
        } else {
          url = config.api.development;
        }
        axios
          .post(`${url}/api/attendee/register`, this.state)
          .then((result) => {
            this.setState({
              email: '',
              firstName: '',
              lastName: '',
              message: 'Thank you for subscribing!',
            });
          })
          .catch((error) => {
            this.setState({ message: 'Sorry, please try again.' });
          });
      }
    } else {
      this.setState({ message: 'All fields are required.' });
    }
  };

  render() {
    return (
      <div className="register-container">
        <div className="register-modal">
          <div className="register-masthead">
 <svg 
   	xmlns="http://www.w3.org/2000/svg" 
        //viewBox='0 0 199.999 21.181' 
 viewBox="0 0 617.8 61.6"
className='logo'
>
      <g>
        <path
          d="m404.7,18.5c-11.4,0-20.7,9.6-20.7,21.5s9.3,21.5,20.7,21.5,17.1-7.3,18.8-17.1h-2.6c-2.3,6.7-6.6,11.4-12.8,11.4s-13.4-3-13.4-17.7h29.1c-1-13.1-9-19.7-19-19.7Zm-9.8,16.9c.2-8,4.2-13.4,9.2-13.4s8.3,4.5,8.6,13.4h-17.8Z"
          fill="#707272"
        />
        <path
          d="m277,56c-7,0-12.8-6-12.8-16.3s5.9-16.7,12.2-16.7,9.8,3.2,11.7,10.4l2.9-.5c-1.8-9.8-8.7-14.3-17.4-14.3s-20.6,9.6-20.6,21.5,9.3,21.5,20.5,21.5,16.7-7.1,17.6-15.9h-2.5c-1.6,6.6-6.2,10.2-11.7,10.2Z"
          fill="#707272"
        />
        <rect x="346" width="10.1" height="60.8" fill="#707272" />
        <rect x="366.6" width="10.1" height="60.8" fill="#707272" />
        <path
          d="m454.2,56c-7,0-12.8-6-12.8-16.3s5.9-16.7,12.2-16.7,9.8,3.2,11.7,10.4l2.9-.5c-1.8-9.8-8.7-14.3-17.4-14.3s-20.6,9.6-20.6,21.5,9.3,21.5,20.5,21.5,16.7-7.1,17.6-15.9h-2.5c-1.6,6.6-6.2,10.2-11.7,10.2Z"
          fill="#707272"
        />
        <path
          d="m496.2,55.2c-4.6,0-7.9-2.9-7.9-8.9v-22.8h16.7v-3.2h-16.7V6.5h-10.1v13.8h-5.8v3.2h5.8v23.9c0,8.6,6.1,14.1,13.8,14.1s13.9-7.9,15-10.4l-1.9-1.2c-2.2,3.1-4.9,5.4-8.9,5.4Z"
          fill="#707272"
        />
        <path
          d="m317.7,18.5c-12.2,0-21,9.6-21,21.5s8.8,21.5,21,21.5,21-9.7,21-21.5-8.8-21.5-21-21.5Zm0,40.1c-6.2,0-9.9-7.1-9.9-18.5s3.6-18.5,9.9-18.5,9.9,7,9.9,18.5-3.6,18.5-9.9,18.5Z"
          fill="#707272"
        />
        <path
          d="m603.9,19.5c-9.1,0-12.2,7.9-13,10.6v-9.9h-10.1v40.5h10.1v-27.8c.6-1.9,2.7-6.2,8-6.2s8.8,4.1,8.8,9.7v24.3h10.1v-25.5c0-9-3.2-15.7-13.9-15.7Z"
          fill="#707272"
        />
        <circle
          cx="519"
          cy="9.6"
          r="6.6"
          transform="translate(145.3 369.8) rotate(-45)"
          fill="#707272"
        />
        <rect
          x="514"
          y="20.2"
          width="10.1"
          height="40.5"
          fill="#707272"
        />
        <path
          d="m552.5,18.5c-12.2,0-21,9.6-21,21.5s8.8,21.5,21,21.5,21-9.7,21-21.5-8.8-21.5-21-21.5Zm0,40.1c-6.2,0-9.9-7.1-9.9-18.5s3.6-18.5,9.9-18.5,9.9,7,9.9,18.5-3.6,18.5-9.9,18.5Z"
          fill="#707272"
        />
      </g>
      <g>
        <path
          d="m214.3,56c-6,0-13.3-3-13.4-17.7h29c-1-13.2-9-19.7-19-19.7s-20.8,9.6-20.8,21.5,9.3,21.5,20.8,21.5,17.1-7.3,18.7-17.1h-2.6c-2.2,6.7-6.6,11.4-12.8,11.4Zm-3.9-33.8c5,0,8.3,4.3,8.6,13.2h-17.9c.2-7.9,4.3-13.2,9.3-13.2Z"
          fill="#ee3124"
        />
        <path
          d="m51.3,18.5c-11.5,0-20.8,9.6-20.8,21.5s9.3,21.5,20.8,21.5,17.1-7.3,18.7-17.1h-2.6c-2.2,6.7-6.6,11.4-12.8,11.4s-13.3-3-13.4-17.7h29c-1-13.2-9-19.7-19-19.7Zm-9.9,16.9c.2-8,4.3-13.3,9.3-13.3s8.3,4.3,8.6,13.2h-17.9Z"
          fill="#ee3124"
        />
        <path
          d="m100.6,19.5c-9.1,0-12.2,7.9-13.1,10.6v-9.9h-10.1v40.6h10.1v-27.8c.7-1.9,2.7-6.3,8-6.3s8.8,4.2,8.8,9.7v24.3h10.4v-25.6c0-9-3.5-15.7-14.2-15.7Z"
          fill="#ee3124"
        />
        <path
          d="m148.1,19.5c-9.1,0-12.2,7.9-13.1,10.6v-9.9h-10.1v40.6h10.1v-27.8c.7-1.9,2.7-6.3,8-6.3s8.8,4.2,8.8,9.7v24.3h10.4v-25.6c0-9-3.5-15.7-14.2-15.7Z"
          fill="#ee3124"
        />
        <rect
          x="172.8"
          y="20.2"
          width="10.1"
          height="40.5"
          fill="#ee3124"
        />
        <circle cx="177.8" cy="9.6" r="6.6" fill="#ee3124" />
        <rect
          y="20.2"
          width="10.1"
          height="40.5"
          fill="#ee3124"
        />
        <circle cx="20.3" cy="26" r="6.5" fill="#ee3124" />
      </g>
    </svg>
            <a href="#close" className="fas fa-times close-register-button">
              <span className="hidden">Close</span>
            </a>
          </div>
          <h2 className="register-header">
            {" "}
            Subscribe to receive our newsletter.{" "}
          </h2>
          <p className="register-text">
            {" "}
            To get immediate notification of this and all other{" "}
            <strong>rennie collection</strong> activities, please fill out the form
            below. We will never sell or share your personal information,
            including your name, email address and phone number.{" "}
          </p>
          <div className="register-inputs">
            <input
              className="name-input"
              name="firstName"
              placeholder="First Name*"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
            <input
              className='name-input'
              name='lastName'
              placeholder='Last Name*'
              value={this.state.lastName}
              onChange={this.handleChange}
            />
            <input
 	      className="email-input"
              name='email'
              value={this.state.email}
              onChange={this.handleChange}
              placeholder='Email'
            />
          </div>
          {this.state.message ? (
            <p className='register-message'> {this.state.message} </p>
          ) : (
            ''
          )}
          <button className='register-button' onClick={this.handleSubmit}>
            {' '}
            Register{' '}
          </button>
        </div>
      </div>
    );
  }
}

export default RegisterForm;

